import {RouterModule, Routes} from '@angular/router';
import {IndexComponent} from "./pages/index/index.component";
import {HomeComponent} from "./pages/home/home.component";
import {PpComponent} from "./pages/privacy-policy/pp.component";
import {TermOfUseComponent} from "./pages/term-of-use/term-of-use.component";

const PRIVATE_ROUTES: Routes = [
    {path: '', component: HomeComponent},
    {path: 'privacy-policy', component: PpComponent},
    {path: 'term-of-use', component: TermOfUseComponent},
];

const appRoutes: Routes = [
    {path: '', component: IndexComponent, children: PRIVATE_ROUTES},
    {path: '**', redirectTo: ''},
];

export const Routing = RouterModule.forRoot(appRoutes);
